/*!
 * devextreme-vue
 * Version: 23.2.5
 * Build date: Mon Mar 11 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

import { defineComponent } from 'vue';
import { initBaseComponent } from './component';
import { getNodeOptions } from './vue-helper';
function initDxExtensionComponent() {
    return defineComponent({
        extends: initBaseComponent(),
        mounted: function () {
            this.$el.setAttribute('isExtension', 'true');
            var nodeOptions = getNodeOptions(this);
            nodeOptions.$_isExtension = true;
            nodeOptions.$_attachTo = this.attachTo.bind(this);
            if (nodeOptions && nodeOptions.$_hasOwner) {
                return;
            }
            this.attachTo(this.$el);
        },
        methods: {
            attachTo: function (element) {
                this.$_createWidget(element);
            },
        },
    });
}
export { initDxExtensionComponent, };
